// src/i18n/index.ts

import { es } from "./es";
import { en } from "./en";
import { fr } from "./fr";


export type LangCode = "es" | "en" | "fr" ;

export type Translations = {
  nav: {
    services: string;
    reviews: string;
    contact: string;
  };
  hero: {
    title: string;
    subtitle: string;
    callNow: string;
    whatsapp: string;
  };
  quickQuote: {
    title: string;
    name: string;
    from: string;
    to: string;
    date: string;
    sendWhatsApp: string;
    helper: string;
  };
  services: {
    title: string;
  };
  reviews: {
    title: string;
    subtitle: string;
  };
  pricing: {
    title: string;
    note: string;
  };
  contact: {
    title: string;
    subtitle: string;
    phone: string;
    whatsapp: string;
    email: string;
    sendMediaTitle: string;
    sendMediaText: string;
    openWhatsApp: string;
  };
};



export const translations: Record<LangCode, Translations> = {
  es,
  en,
  fr,
};

export const DEFAULT_LANG: LangCode = "es";